import {
  Component,
  OnInit,
  DoCheck,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { SideBar } from '../shared/component/sidebar/siderbar';
import { Router } from '@angular/router';
import { LanguageService } from '../service/language.service';
import { RoomNoService } from '../service/room-no.service';
import { KeyCode } from '../shared/const/KeyCode';
import { BraviaApiService } from '../service/bravia-api.service';
import { delay } from 'rxjs';

@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.scss']
})
export class StreamingComponent implements OnInit, DoCheck, AfterViewInit {
  appname: string;

  focusIndex = 0;
  hotelIndex = 0;
  lang = '';
  FullScreen = false;
  FirstTime = false;
  movie_url = [
    'http://iids-ch1.multicdnet.com/live_1/playlist.m3u8',
    'http://iids-ch4.multicdnet.com/live_1/playlist.m3u8',
    'http://iids-ch8.multicdnet.com/live_1/playlist.m3u8',
    'http://iids-ch3.multicdnet.com/live_1/playlist.m3u8',
    'http://iids-ch6.multicdnet.com/live_1/playlist.m3u8'
  ];

  sidebar: SideBar<any, any>[] = [
    {
      title: 'NHK WORLD JAPAN',
      title_jpn: 'NHK WORLD JAPAN',
      title_eng: 'NHK WORLD JAPAN',
      key_code: '1',
      checked: true,
      focused: false,
      icon: '/assets/icons/com/nhk.png'
    },
    {
      title: 'CNA',
      title_jpn: 'CNA',
      title_eng: 'CNA',
      key_code: '2',
      checked: false,
      focused: false,
      icon: '/assets/icons/com/cna.png'
    },

    {
      title: 'ABC Australia',
      title_jpn: 'ABC Australia',
      title_eng: 'ABC Australia',
      key_code: '3',
      checked: false,
      focused: false,
      icon: '/assets/icons/com/abc.png'
    },
    {
      title: 'YTN',
      title_jpn: 'YTN',
      title_eng: 'YTN',
      key_code: '4',
      checked: false,
      focused: false,
      icon: '/assets/icons/com/ytn.png'
    },
    {
      title: 'CTI ASIA',
      title_jpn: 'CTI ASIA',
      title_eng: 'CTI ASIA',
      key_code: '5',
      checked: false,
      focused: false,
      icon: '/assets/icons/com/cti.png'
    },

    {
      title: 'メニューへ戻る',
      title_jpn: 'メニューへ戻る',
      title_eng: 'Back to Menu',
      key_code: '92',
      checked: false,
      focused: false
    }
  ];

  constructor(
    private roomNoService: RoomNoService,
    private router: Router,
    private languageService: LanguageService,
    private braviaApiService: BraviaApiService,
    private elementRef: ElementRef
  ) {}

  @ViewChild('movie') movie: ElementRef;

  ngAfterViewInit(): void {
    this.movie.nativeElement.volume = 0.3;
    this.movie.nativeElement.src = this.movie_url[0];
  }

  ngDoCheck() {
    if (this.movie) {
      this.movie.nativeElement.volume = 0.3;
    }
  }

  ngOnInit(): void {
    this.appname = '多言語放送';
    // Languageをサービスしちゃう

    this.lang = this.languageService.language;

    if (this.languageService.language === 'eng') {
      this.appname = 'Multilingual Broadcast';
      this.sidebar = this.sidebar.map(d => {
        d.title = d.title_eng;
        return d;
      });
    } else {
      this.appname = '多言語放送';
    }
    document.onkeydown = this.pushButton.bind(this);
  }

  setFocusIndex(index: number) {
    //this.controlShow = true;
    this.focusIndex = index;
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.focusIndex].checked = true;
    this.sidebar.forEach(d => (d.focused = false));
    this.sidebar[this.focusIndex].focused = true;
    if (index != 5) {
      this.hotelIndex = index;
    }
    this.movie.nativeElement.src = this.movie_url[index];
  }

  setClickIndex(index: number) {
    //this.controlShow = true;
    if (index === 5) {
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }

  pushButton(ev: KeyboardEvent) {
    if (ev.key === 'Enter' && this.FullScreen) {
      // 決定キーが押されてフルスクリーンの場合は解除
      console.log('Change to window Mode mode');
      this.FullScreen = false;
    } else if (ev.key === 'Enter' && !this.FirstTime) {
      // 決定キーがおされて初回でない場合はフルスクリーン
      console.log('Change to window mode');
      this.FullScreen = true;
    } else if (ev.key === 'Enter' && this.FirstTime === true) {
      // 初回だった場合は無視
      console.log('First Time');
      this.FirstTime = false;
    } else {
      // それ以外は初回にする
      console.log('soreigai');
      this.FirstTime = true;
    }

    console.log(ev.keyCode);
    console.log('Fullscreen' + this.FullScreen);
  }
}
